





































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Modal from '@/components/Modal.vue'
import { ChainModule } from '@/store/modules/chain.module'
import { UserModule } from '@/store/modules/user.module'
import { EAdminTaskStatus, ETrainingMilestoneStatus, IAdminTask, ITrainingMilestone, ITrainingMilestoneTemplate } from '@zunta/configurations'
import Checkbox from '@/components/inputsV2/Checkbox.vue'

const groupBy = require('lodash.groupby')
const sortBy = require('lodash.sortby')

@Component({
  components: {
    Modal,
    Checkbox
  }
})
export default class TrainingSettingsModal extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  milestones: ITrainingMilestone[] = [];
  ETrainingMilestoneStatus: any = ETrainingMilestoneStatus;

  get user () {
    return this.$store.state.user.selectedUser
  }

  get allMilestones () {
    return this.$store.state.user.trainingMilestones
  }

  get groupedMilestones () {
    if (this.milestones.length === 0) {
      return []
    }
    const milestones = this.milestones
    const group: any[] = []
    const groupedByParent = groupBy(milestones, (milestone: ITrainingMilestone) => (
      (milestone.template as ITrainingMilestoneTemplate).parent || '0'
    ))
    const parents = groupedByParent['0']
    const groupedById = groupBy(milestones, (milestone: ITrainingMilestone) => (
      (milestone.template as ITrainingMilestoneTemplate).id
    ))
    Object.keys(groupedByParent).forEach((key) => {
      if (key === '0') return
      group.push({
        parent: groupedById[key][0],
        sub: sortBy(groupedByParent[key], (milestone: ITrainingMilestone) => (
          (milestone.template as ITrainingMilestoneTemplate).order
        ))
      })
    })
    parents.forEach((parent: ITrainingMilestone) => {
      if (!group.find((item) => item.parent.id === parent.id)) {
        group.push({
          parent,
          sub: []
        })
      }
    })
    return group
  }

  mounted () {
    this.milestones = JSON.parse(JSON.stringify(this.allMilestones))
  }

  changeStatus (milestone: ITrainingMilestone, $event: boolean) {
    milestone.required = $event
    const mTemplate = milestone.template as ITrainingMilestoneTemplate
    if (!mTemplate.parent) {
      if (!milestone.required) {
        const subMilestones = this.milestones.filter((m: ITrainingMilestone) => {
          const sTemplate = m.template as ITrainingMilestoneTemplate
          return sTemplate.parent === mTemplate.id
        })
        subMilestones.forEach((subMilestone) => {
          subMilestone.required = milestone.required
        })
      }
    } else {
      if (milestone.required) {
        const parentMilestone = this.milestones.find((m) => {
          const pTemplate = m.template as ITrainingMilestoneTemplate
          return pTemplate.id === mTemplate.parent
        })
        if (parentMilestone) {
          parentMilestone.required = milestone.required
        }
      }
    }
  }

  async save () {
    await this.userModuleInstance.saveTrainingMilestones({
      userId: this.user.id,
      milestones: this.milestones
    })
    this.$emit('close')
  }
}
